import AlertDetailsPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/AlertDetailsPage";
import Classes, { NotificationDetail } from "model";
import { BCMSRecord, useBCMSContext, BCMSStateManagerCRUD } from "bcms-react";

export default function CaptureNotifiLimAlertActive(props) {
    const controller = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, controller);

    const notification = NotificationDetail.initByID("2");
    notification.contactInfoEnabledIDs = ["0", "1"];

    NotificationDetail.update(notification)
        .submit(Classes);
    
    const data = getDefaultPageData("26");
    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
        .update([ "Detail_2" ], { action: "added" })
        .submit();

    return <AlertDetailsPage data={ data } ui={ ui } />
}